var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blankstate"},[_c('div',{staticClass:"columns"},[(_vm.$slots.left)?_c('div',{staticClass:"column is-offset-1 is-3 left-content"},[_vm._t("left")],2):_vm._e(),_c('div',{staticClass:"column",class:{ 'is-7': _vm.$slots.left }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }